import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

import * as color from 'modules/common/theme/color';
import * as font from 'modules/common/theme/font';

const WrapperLink = styled(Link)`
  display: block;
  width: 212px;
  position: relative;
  cursor: pointer;
  text-align: center;

  &,
  &:hover {
    color: inherit;
  }
`;

const HoverWrapper = styled.div`
  position: absolute;
  background-color: rgba(40, 55, 70, 0.85);
  top: 3px;
  left: 4px;
  display: none;
  width: calc(100% - 8px);
  height: calc(100% - 6px);
  align-items: center;
  flex-direction: column;
  justify-content: center;

  ${WrapperLink}:hover & {
    display: flex;
  }
`;
const RoundedLinkButton = styled(Link)`
  background: transparent;
  border: 1px solid ${color.White} !important;
  border-radius: 19px !important;
  color: ${color.White};
  padding: 0 35px;
  text-transform: uppercase;
  font: 700 12px / 12px ${font.NunitoFont};
  height: 34px;
  line-height: 34px;
  letter-spacing: 1px;
  margin-bottom: 5px;
  outline: none;
  transition: all 0.3s;

  :hover,
  :focus,
  :active {
    background-color: ${color.White};
    color: ${color.Black};
  }
`;

const LinkButton = styled(Link)`
  background: none;
  border: none;
  color: white;
  text-transform: uppercase;
  font: 700 12px / 12px ${font.NunitoFont};
  border-bottom: 1px solid transparent;
  margin-top: 7px;

  :hover,
  :focus,
  :active {
    background: none;
    color: ${color.White};
    border-bottom: 1px solid ${color.White};
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  height: auto;
  display: block;
  height: auto;
  overflow: hidden;
  border-radius: 6px;
  border: 1px solid ${color.lightBackground};
  transition: border 0.5s ease;

  a {
    width: 100%;
  }

  img {
    width: 212px;
    height: 328px;
    object-fit: fill;
    will-change: transform;
    transition: transform 0.5s ease;
    transform: scale(1.03);
  }

  &:hover {
    border-color: ${color.BookCatalogHeaderBg};

    img {
      transform: scale(1);
    }
  }
`;
const upgradeDiv = styled.div`
  width: 220px;
  height: 180px;
  background: ${color.Black} 0% 0% no-repeat padding-box;
  opacity: 0.75;
`;
const Title = styled.span`
  width: 100%;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  margin-top: 15px;
  display: inline-block;
`;

export default {
  WrapperLink,
  ImageWrapper,
  Title,
  HoverWrapper,
  RoundedLinkButton,
  LinkButton,
  upgradeDiv,
};
